import { render, staticRenderFns } from "./ViewOnGithub.vue?vue&type=template&id=7f5a5674&scoped=true"
import script from "./ViewOnGithub.vue?vue&type=script&lang=js"
export * from "./ViewOnGithub.vue?vue&type=script&lang=js"
import style0 from "./ViewOnGithub.vue?vue&type=style&index=0&id=7f5a5674&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f5a5674",
  null
  
)

export default component.exports